import classNames from "classnames";
import { RichText } from "components/RichTextWidget";
import { useTranslation } from "features/translations";
import { useMemo } from "react";
import { Heading5, Icon, PageLink, Paragraph } from "shared/components";
import { useViewMode } from "shared/contexts/ViewMode";
import { useToggle } from "shared/hooks";
import { truncateText } from "shared/utils";

import styles from "./Item.module.scss";

const DEFAULT_VISIBLE_DESCRIPTION = 145;
const DEFAULT_VISIBLE_LIST = 200;

export const Item = ({
  course,
  heading,
  description,
  coursesList,
  coursesQuantity,
  appearance,
}) => {
  const { isDesktop } = useViewMode();
  const { t } = useTranslation();

  const truncatedDescription = useMemo(() => {
    return truncateText(description, DEFAULT_VISIBLE_DESCRIPTION);
  }, [description]);

  const truncatedList = useMemo(() => {
    return truncateText(coursesList, DEFAULT_VISIBLE_LIST);
  }, [coursesList]);

  const { opened, onOpen, onClose } = useToggle();

  const hover = {
    ...(isDesktop &&
      coursesList && {
        onMouseOver: onOpen,
        onMouseLeave: onClose,
      }),
  };

  return (
    <PageLink directory="programs" slug={course?.slug}>
      <div
        className={classNames(styles.wrapper, {
          [styles["grey"]]: appearance === "light",
        })}
        {...hover}
      >
        <div
          className={classNames(styles["content-inner"], {
            [styles["rotate"]]: opened,
          })}
        >
          <div className={styles["content-front"]}>
            <Heading5 className={styles.title} color="dark">
              {heading}
            </Heading5>
            <RichText value={truncatedDescription} className={styles.courses} />
            {coursesQuantity && (
              <div className={styles["course-amount"]}>
                <Paragraph color="grey">{t("course_amount")}</Paragraph>
                <Paragraph
                  className={styles.amount}
                  appearance="bold"
                  color="brand"
                >
                  {coursesQuantity}
                </Paragraph>
              </div>
            )}
          </div>
          <div className={styles["content-back"]}>
            <RichText value={truncatedList} className={styles["course-list"]} />
          </div>
        </div>

        <span className={styles.arrow}>
          <Icon className={styles.icon} name="arrow_right" />
        </span>
      </div>
    </PageLink>
  );
};
